import { useQuery } from 'urql';

const CUSTOMER_QUERY = `
  query CurrentCustomer {
    customer: currentCustomer {
      customerId
      uuid
      fullName
      phoneNumber
      email
      addresses {
        uuid
        fullName
        telephone
        isDefault
      }
    }
  }
`;

export const useAuth = () => {
  const [result] = useQuery({
    query: CUSTOMER_QUERY
  });

  const { data, fetching, error } = result;

  return {
    customer: data?.customer,
    isAuthenticated: !!data?.customer?.customerId,
    loading: fetching,
    error
  };
};
